import React from 'react'

// Services
import VendorAdvancesServices from 'Services/Api/MasterData/vendorAdvances'
import ProjectsServices from 'Services/Api/MasterData/project'
import GLAccountServices from 'Services/Api/MasterData/glAccount'
import AdvanceProjectClass from 'Services/Api/ProjectClass/projectClass'
import TransactionServices from 'Services/Api/NonPOItem/nonPOItem'
import ItemNumberServices from 'Services/Api/MasterData/itemNumber'

export default function OnChange(args) {
  const {
    event,
    isSuggestionClick,
    index,
    name,
    isProjectClass = false,
    params,
    setSuggestionsWtaxRate,
    setSuggestionsVatType,
    setSuggestion,
    suggestion,
    handleOnComputation,
    setValue,
    value
  } = args
  if (isProjectClass) {
    let projectClass = [...value.projectClass]
    projectClass[parseInt(index)][name] = event
    setValue({ ...value, projectClass: projectClass })
    if (isSuggestionClick) {
      for (let i of suggestion) {
        if (event === i) {
          setValue({ ...value, projectClass: projectClass })
        }
      }
    }
    handleOnComputation()
    let _params = {
      sort: 1,
      ...params
    }
    _params.search = event ? event : toString(event)
    switch (name) {
      case 'glAccount':
        GLAccountServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(`${items.accountCode} ${items.accountName}`)
          })
          setSuggestion(newData)
        })
        break
      case 'projectClass':
        AdvanceProjectClass.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items)
          })
          setSuggestion(newData)
        })
        break
      case 'itemNumber':
        ItemNumberServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.itemNo)
          })
          setSuggestion(newData)
        })
        break
    }
  } else {
    setValue({ ...value, [name]: event })
    if (isSuggestionClick) {
      suggestion.map(i => {
        if (event === i) {
          setValue({ ...value, [name]: event })
        }
      })
    }
    let _params = {
      sort: 1,
      ...params
    }
    _params.search = event ? event : toString(event)
    switch (name) {
      case 'project':
        ProjectsServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.projectName)
          })
          const index = newData.indexOf('Megawide - Holding Company')
          if (index > -1) newData.splice(index, 1)
          const index2 = newData.indexOf('Megawide - Main or Head Office')
          if (index2 > -1) newData.splice(index2, 1)
          setSuggestion(newData)
        })
        break
      case 'vendor':
        VendorAdvancesServices.getMany(_params).then(res => {
          const data = res.data.data
          const vendor = []
          const taxRate = []
          data.map(items => {
            vendor.push(items.bpName)
          })
          setSuggestion(vendor)
        })
        break
    }
  }
}
